var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export function SALogoNoBrandingLogoBugWhite(_a) {
    var name = _a.name, additionalProps = __rest(_a, ["name"]);
    return (React.createElement("svg", __assign({}, additionalProps, { width: "60px", height: "35px", viewBox: "0 0 60 35", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", fillOpacity: "0.8" },
            React.createElement("g", { transform: "translate(0.000000, -5.000000)", fill: "#FFFFFF" },
                React.createElement("rect", { x: "0", y: "5", width: "60", height: "35", rx: "4" })))));
}
//# sourceMappingURL=logo.nobrandlogo-bug-white.component.js.map